import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IFilters } from 'coreOld/types';
import { getFormData, getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';
import { IAccessRank } from 'system/types';

export const getAllUsersRanks = async (
  filters: IFilters
): Promise<GetManyResponse<IAccessRank>> => {
  const { data } = await partfinitiClient.get(
    `/user/user-resource-list/resources?${getQueryString(objectKeysCamelToSnakeCase(filters))}`
  );

  return mapRecordsFromServer<IAccessRank>(data.data, data.recordsFiltered);
};

export const addUserRanksBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/rank-association-edit/save-bulk', dataToSend);
};

export const removeUserRanksBulk = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/rank-association-edit/remove-bulk', dataToSend);
};

export const setUserRankResource = async (data) => {
  const dataToSend = getFormData(data);

  return partfinitiClient.post('/user/rank-resource-association-edit/set-association', dataToSend);
};
